/** Chave usada pelo banner em `components/cookiesConsent.tsx`. */
export const CONSENT_STORAGE_KEY = "cookieConsent";

export type ConsentValue = "accepted" | "declined" | null;

/**
 * Decide se dá para medir a partir do que a pessoa respondeu no banner.
 *
 * A base legal aqui é legítimo interesse, não consentimento: são ferramentas de
 * produto operadas por fornecedor contratado, sem venda de dado. Por isso quem
 * ainda não respondeu continua sendo medido — o que a lei exige em troca é
 * transparência e um opt-out que funcione de verdade.
 *
 * "De verdade" é a parte que importa: esta função precisa valer para *todos* os
 * fornecedores. Um botão "Recusar" que desliga só um deles é pior que botão
 * nenhum, porque promete o que não cumpre.
 */
export const canTrack = (consent: ConsentValue): boolean =>
  consent !== "declined";

/** Lê a resposta do banner no browser. Fora dele, não mede. */
export const hasTrackingConsent = (): boolean => {
  if (typeof window === "undefined") return false;

  try {
    return canTrack(
      localStorage.getItem(CONSENT_STORAGE_KEY) as ConsentValue,
    );
  } catch {
    // Safari em modo privado pode barrar localStorage. Sem resposta legível,
    // segue a regra do não-respondido.
    return true;
  }
};
